module.exports = __webpack_public_path__ + "static/masonry-image-5-e5e649aee5610a8b5b6a3da87f7b8127.jpg";